import React from 'react';
import { Button } from '@/components/ui/button';
import { Delete, Check } from 'lucide-react';

interface CustomNumericKeypadProps {
  onNumberPress: (number: string) => void;
  onBackspace: () => void;
  onConfirm: () => void;
  numberButtonsDisabled?: boolean;
  confirmButtonDisabled?: boolean;
}

export const CustomNumericKeypad = ({
  onNumberPress,
  onBackspace,
  onConfirm,
  numberButtonsDisabled = false,
  confirmButtonDisabled = false
}: CustomNumericKeypadProps) => {
  const numbers = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9'],
  ];

  return (
    <div className="grid grid-cols-3 gap-3 p-4 bg-background border rounded-lg">
      {numbers.map((row, rowIndex) =>
        row.map((number) => (
          <Button
            key={number}
            variant="outline"
            size="lg"
            className="h-14 text-lg font-semibold"
            onClick={() => onNumberPress(number)}
            disabled={numberButtonsDisabled}
          >
            {number}
          </Button>
        ))
      )}
      
      {/* Bottom row */}
      <Button
        variant="outline"
        size="lg"
        className="h-14 text-lg font-semibold"
        onClick={onBackspace}
        disabled={numberButtonsDisabled}
      >
        <Delete className="w-5 h-5" />
      </Button>
      
      <Button
        variant="outline"
        size="lg"
        className="h-14 text-lg font-semibold"
        onClick={() => onNumberPress('0')}
        disabled={numberButtonsDisabled}
      >
        0
      </Button>
      
      <Button
        variant="default"
        size="lg"
        className="h-14 text-lg font-semibold"
        onClick={onConfirm}
        disabled={confirmButtonDisabled}
      >
        <Check className="w-5 h-5" />
      </Button>
    </div>
  );
};